import { render, staticRenderFns } from "./YearTrafficRefactored.vue?vue&type=template&id=1dfa2fa6&"
import script from "./YearTrafficRefactored.vue?vue&type=script&lang=js&"
export * from "./YearTrafficRefactored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports